import { ActualizarDepartamentoMunicipio } from '../models/actualizar-departamento-municipio.model';
import { ApiService } from './../../../../../../core/services/apiservice';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class actualizarDepartamentoMunicipioService {

    constructor(private apiService: ApiService) { }
    
    postActualizacionDepartamentoMunicipio(body:ActualizarDepartamentoMunicipio){
        const url= `/bien_cultural/cambio_departamento_municipio` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al actualizar información.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }
}